import { render } from "./FootView.vue?vue&type=template&id=000ee58c&scoped=true"
const script = {}

import "./FootView.vue?vue&type=style&index=0&id=000ee58c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000ee58c"]])

export default __exports__